"use client"
import React, { useState, useEffect } from 'react'
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { formatDateShort } from '@/app/helpers';
import { useTheme } from '@/app/theme-provider';

import Pegination from './Pegination';
import Loader from './Loader';

const ContactusDircetorate = () => {
    const { language } = useTheme();
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(12);

    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm);
            setCurrentPage(1); // reset to page 1 when searching
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data: list = [], totalPages, loading, error } = useFetch(
        "/website/contacts-directorate",
        {
            page: currentPage,
            limit: limit,
            search: debouncedSearch,
        },
        [debouncedSearch, currentPage, limit]
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <>
            <div className='row'>
                <div className='col'>
                    <div className='dircetorate-contact'>
                        <h4>VIGILANCE AND ANTI-CORRUPTION BUREAU</h4>
                        <h4>DIRECTORATE</h4>
                        <p>PMG, Vikas Bhavan P.O, Opposite KSRTC Depot, <br />Thiruvananthapuram, Kerala-695033</p>
                        <p>
                            <span>0471-2305393 ,</span>
                            <span className='mx-2'>vig.vacb@kerala.gov.in ,</span>
                            <span>0471-2305033</span>
                        </p>
                    </div>
                </div>
            </div>
            <section className=''>
                <div className="row mb-3 justify-content-end">
                    <div className="search-box d-flex align-items-center">
                        <input
                            type="text"
                            placeholder={language === "en" ? "Search" : "തിരയുക..."}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                {/* {loading ? (
                    <>
                        <Loader n={24} f={0.3} />

                    </>
                ) : <>
                    <div className="table-responsive tenders-table">
                        <table className="table  table-bordered text-center align-middle ">
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">{language == "en" ? "Sl No." : "ക്രമം നമ്പർ"}</th>
                                    <th scope="col">{language == "en" ? "Name" : "പേര്"} </th>
                                    <th scope="col"> {language == "en" ? "Designation" : "പദവി"}</th>
                                    <th scope="col">{language == "en" ? "Office No." : "ഓഫീസ് നം."}</th>
                                    <th scope="col">{language == "en" ? "Mobile No." : "മൊബൈൽ നമ്പർ."}</th>
                                    <th scope="col">{language == "en" ? "E-mail" : "ഇ-മെയിൽ"}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list?.length > 0 ? (
                                    <>
                                        {list?.map((item, index) => (
                                            <>
                                                <tr key={index}>
                                                    <td>{(currentPage - 1) * limit + index + 1}</td>                                                <td>{item?.name}</td>
                                                    <td>
                                                        {item?.designation}
                                                    </td>
                                                    <td>
                                                        {item?.office_no}
                                                    </td>
                                                    <td>
                                                        {item?.mobile_no}
                                                    </td>
                                                    <td>
                                                        {item?.email}
                                                    </td>
                                                </tr>

                                            </>
                                        ))}

                                    </>
                                ) : <>
                                    <tr>
                                        <td colSpan={6}>
                                            No data found
                                        </td>
                                    </tr>
                                </>}


                            </tbody>
                        </table>
                    </div>
                    {totalPages > 1 && (
                        <Pegination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}

                </>} */}
                {loading ? (
                    <Loader n={24} f={0.3} />
                ) : (
                    <>
                        <div className='card-grid units mt-4'>
                            {list?.length > 0 ? (
                                list.map((item, index) => (
                                    <div key={index} className='card'>
                                        <div>
                                            <h3>{item?.name}</h3>
                                            <p className="designation">{item?.designation}</p>

                                            {/* Office Phone */}
                                            <p>
                                                <img className='ph' src="/icons/unitph.svg" alt="phone" />
                                                <span className='mx-2'>{item?.office_no || "N/A"}</span>
                                            </p>

                                            {/* Mobile Phone */}
                                            {item?.mobile_no && (
                                                <p>
                                                    <img className='ph' src="/icons/unitcel.svg" alt="mobile" />
                                                    <span className='mx-2'>{item?.mobile_no}</span>
                                                </p>
                                            )}

                                            {/* Email */}
                                            {item?.email && (
                                                <p>
                                                    <img src="/icons/unitemail.svg" className='ph' alt="mobile" />
                                                    <span className='mx-2' style={{ fontSize: '14px', wordBreak: 'break-all' }}>{item?.email}</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center">
                                    <h4>{language === "en" ? "No data found" : "വിവരങ്ങൾ ലഭ്യമല്ല"}</h4>
                                </div>
                            )}
                        </div>

                        {totalPages > 1 && (
                            <div className="mt-4">
                                <Pegination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}
                    </>
                )}
            </section>
        </>
    )
}

export default ContactusDircetorate
